import * as types from '../../actions/actiontypes';
import {HttpStatusCodes, notSectorSpecific} from '../../util/uiconstants';
import initialstate from '../initialstate';

const knowledgeDataReducer = (state = initialstate.knowledgeData, action) => {
	switch (action.type) {
		case types.GET_KNOWLEDGE_INDUSTRIES:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				const filteredResponse = action.response.filter((item) => item.industryDisplayName !== notSectorSpecific);
				const items = filteredResponse.map((item) => {
					return {
						key: item.industryId,
						value: item.industryId,
						label: item.industryDisplayName
					};
				});
				return {
					...state,
					knowledgeIndustries: items
				};
			}
			return state;
		case types.GET_KNOWLEDGE_ACCOUNTS:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				const items = action.response.map((item) => {
					return {
						key: item.accountId,
						id: item.accountId,
						accountName: item.accountName,
						checked: false
					};
				});
				return {
					...state,
					knowledgeAccounts: items
				};
			}
			return state;
		case types.POST_KNOWLEDGE_ACCOUNT:
			if (action.response) {
				return {...state, data: action.response};
			}
			return state;
		case types.SET_SELECTED_INDUSTRY: {
			return {...state, selectedIndustry: action.data};
		}
		case types.SET_SELECTED_ACCOUNTS: {
			return {...state, knowledgeAccounts: action.data};
		}
		case types.SET_SELECTED_SCOT: {
			return {...state, selectedScot: action.data};
		}
		case types.GET_KNOWLEDGE_ENTITY_DATA: {
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				return {...state, knowledgeEntityData: action.response};
			}
			return state;
		}
		case types.POST_KNOWLEDGE_SCOT: {
			if (action.response) {
				return {...state, data: action.response};
			}
			return state;
		}
		case types.POST_KNOWLEDGE_OSP: {
			if (action.response) {
				return {...state, data: action.response};
			}
			return state;
		}
		case types.RESET_SELECTED_INDUSTRY: {
			return {...state, selectedIndustry: []};
		}
		case types.RESET_SELECTED_SCOT: {
			return {...state, selectedScot: []};
		}
		case types.POST_KNOWLEDGE_WCGW: {
			if (action.response) {
				return {...state, data: action.response};
			}
			return state;
		}
		case types.POST_KNOWLEDGE_CONTROL: {
			if (action.response) {
				return {...state, data: action.response};
			}
			return state;
		}
		default:
			return state;
	}
};

export default knowledgeDataReducer;
